document.addEventListener("DOMContentLoaded", function() {
    function customPopups() {
        function cpopTogglePopup(popupId) {
            const popup = document.querySelector(`[data-custom-popup-id="${popupId}"]`);
            if (popup) {
                const isVisible = popup.style.display === "block";
                popup.style.display = isVisible ? "none" : "block";
                document.body.classList.toggle('no-scroll', !isVisible);
            }
        }

        function cpopOpenPopup(popupId) {
            const popup = document.querySelector(`[data-custom-popup-id="${popupId}"]`);
            if (popup && popup.style.display !== "block") {
                popup.style.display = "block";
                document.body.classList.add('no-scroll');
            }
        }

        function cpopCloseAllPopups() {
            const popups = document.querySelectorAll('.cpop-popup');
            let anyPopupVisible = false;
            popups.forEach(popup => {
                if (popup.style.display === 'block') {
                    popup.style.display = 'none';
                    anyPopupVisible = true;
                }
            });
            if (anyPopupVisible) {
                document.body.classList.remove('no-scroll');
            }
        }

        // Delegated listener survives section re-renders in the Shopify editor. Added due to issues with the navigation popup not closing when clicking around the close button or outside the popup.
        document.addEventListener('click', function(event) {
            const trigger = event.target.closest('[data-custom-popup-trigger]');
            if (trigger) {
                const popupId = trigger.getAttribute('data-custom-popup-trigger');
                const popup = document.querySelector(`[data-custom-popup-id="${popupId}"]`);
                const isOpen = popup && popup.style.display === 'block';
                cpopCloseAllPopups();
                if (!isOpen) cpopOpenPopup(popupId);
                return;
            }
            if (event.target.closest('[data-custom-popup-close]')) {
                cpopCloseAllPopups();
                return;
            }
            if (event.target.classList.contains('cpop-popup')) {
                cpopCloseAllPopups();
            }
        });

        document.addEventListener('keydown', function(event) {
            if (event.key === 'Escape') cpopCloseAllPopups();
        });

        function autoTriggerPopup() {
            const navigationPopup = document.querySelector('[data-custom-popup-id="navigation-menu"]');
            if (!navigationPopup) return;
            
            if (window.Shopify && window.Shopify.designMode) {
                if (window.navPopupSettings?.previewMode) {
                    cpopOpenPopup('navigation-menu');
                }
                return;
            }

            const settings = window.navPopupSettings || {};
            const hasSeenPopup = sessionStorage.getItem('navigation-popup-shown');
            
            const config = {
                enabled: settings.enabled !== undefined ? settings.enabled : true,
                delay: settings.delay !== undefined ? settings.delay : 1000,
                showOnce: settings.showOnce !== undefined ? settings.showOnce : true
            };

            if (!config.enabled || (config.showOnce && hasSeenPopup)) return;

            setTimeout(() => {
                cpopOpenPopup('navigation-menu');
                sessionStorage.setItem('navigation-popup-shown', 'true');
            }, config.delay);
        }

        autoTriggerPopup();
        document.addEventListener('shopify:section:load', autoTriggerPopup);
        window.cpopOpenPopup = cpopOpenPopup;
    }

    customPopups();
});
